module.exports = __webpack_public_path__ + "static/media/icon-mail-blue.1e0acd53.svg";